export var UIEvent;
(function (UIEvent) {
    UIEvent["SHOW_TIP"] = "showtip";
    UIEvent["HIDE_TIP"] = "hidetip";
})(UIEvent || (UIEvent = {}));
